import { checkPermission } from "library/authorization/index.mjs"
import { Lazy } from "lib/make-lazy"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { canAccessProjectsTab } from "./review-project-route-access"
import { FEATURE_FLAG_REVIEW_PROJECTS } from "./server/feature-flag-review-projects.mjs"

export function ReviewProjectRunResolutionRoute() {
    if (checkPermission(`$feature-${FEATURE_FLAG_REVIEW_PROJECTS}`) && canAccessProjectsTab()) {
        return (
            <Lazy
                importer={() => import("./routes/review-project-run-resolution-detail-page")}
                extract="ReviewProjectRunResolutionDetailPage"
            />
        )
    }

    return <DemandGuard demands={`$feature-${FEATURE_FLAG_REVIEW_PROJECTS}`}>{null}</DemandGuard>
}
